import PropTypes from 'prop-types';
import React from 'react';
import cx from 'classnames';
import AnimateHeight from 'react-animate-height';
import helpers from '../../helpers';
import { ExitStatus } from 'typescript';
import reactT from '../reactT';
import ShowAllModal from "../../components/ShowAllModal";
import Popovers from "../Popovers/Popovers";

class FederatedListFacet extends React.Component {

  constructor(props) {
    super(props);

    this.state = {
      filter: '',
      truncateFacetListsAt: 7,
      textFilter: "",
      selectedFilters: this.props.value || [],
    };
  }

  componentDidUpdate(prevProps) {
    if (JSON.stringify(prevProps.value) !== JSON.stringify(this.props.value)) {
      this.setState({ selectedFilters: [...this.props.value] });
    }
  }

  handleClick = (value) => {
    const {
      foundIdx,
      parsed,
      isQsParamField,
      param,
    } = helpers.qs.getFieldQsInfo({
      field: this.props.field,
      values: this.props.value,
      value,
    });

    // Define var for new parsed qs params object.
    let newParsed = parsed;

    // Update the selected filters state
    let updatedFilters = [...this.state.selectedFilters];
    if (foundIdx < 0) {
      updatedFilters.push(value);
    } else {
      updatedFilters = updatedFilters.filter((v) => v !== value);
    }
    this.setState({
      selectedFilters: updatedFilters,
    });

    // If the clicked list facet field is one whose state is tracked in the qs.
    if (isQsParamField) {
      const categoryMapping = this.props.categoryMapping;
      // If the click is adding the field value.
      if (foundIdx < 0) {
        // If there is already a qs param for this field value.
        if (param) {
          // Add value to parsed qs params.
          newParsed = helpers.qs.addValueToQsParam({
            field: this.props.field,
            value,
            param,
            parsed,
          });
        } else { // If there is not already a qs param for this field value.
          // Add new qs param for field + value.
          newParsed = helpers.qs.addQsParam({
            field: this.props.field,
            value,
            parsed,
          });
        }

        // Remove the hidden drupalSettings.filter value from the current query once a facet filter is clicked.
        if (typeof drupalSettings !== 'undefined' && typeof drupalSettings.filter !== 'undefined' && categoryMapping[drupalSettings.type] === this.props.field) {
          if (this.props.value.indexOf(drupalSettings.filter) > -1) {
            this.props.value.splice(this.props.value.indexOf(drupalSettings.filter), 1);
          }
        }

        // Send new query based on app state.
        this.props.onChange(this.props.field, this.props.value.concat(value));
      } else { // If the click is removing this field value.
        // If their is already a qs param for this field value.
        if (param) {
          newParsed = helpers.qs.removeValueFromQsParam({
            field: this.props.field,
            value,
            param,
            parsed,
          });
        }

        // Add the hidden drupalSettings.filter value to the current query when this.props.value is empty.
        let filteredValues = this.props.value.filter((v, i) => i !== foundIdx);
        if (typeof drupalSettings !== 'undefined' && typeof drupalSettings.filter !== 'undefined' && categoryMapping[drupalSettings.type] === this.props.field) {
          if (filteredValues.length === 0) {
            filteredValues = [drupalSettings.filter];
          }
        }
        // Send new query based on app state.
        this.props.onChange(this.props.field, filteredValues);
      }

      helpers.qs.addNewUrlToBrowserHistory(newParsed);
    }
  };

  handleModalClick = (value) => {
    let updatedFilters = [...this.state.selectedFilters]; // Start with current selected filters

    const foundIdx = updatedFilters.indexOf(value);

    if (foundIdx < 0) {
      // Add the value to the selected filters list
      updatedFilters.push(value);
    } else {
      // Remove the value from the selected filters list
      updatedFilters = updatedFilters.filter((v) => v !== value);
    }

    // Store the updated filters in the component's state
    this.setState({
      selectedFilters: updatedFilters,
    });
  };

  handleApplyFilters = () => {
    const { selectedFilters } = this.state;

    // Get current parsed params
    const { parsed } = helpers.qs.getFieldQsInfo({
      field: this.props.field,
      values: selectedFilters,
    });

    // Update parsed with the selected filters for this field
    parsed[this.props.field] = [...selectedFilters];

    // Send the query based on selected filters
    this.props.onChange(this.props.field, selectedFilters);

    // Add the new query to the browser history
    helpers.qs.addNewUrlToBrowserHistory(parsed);
  };

  toggleExpand(hierarchyFacetValue) {
    this.props.onSetCollapse(this.props.field, !(this.props.collapse || false));
    // If this is a hierarchical list facet.
    if (hierarchyFacetValue) {
      // Determine the current state of the expanded hierarchical list facets.
      const indexOfExpandedHierarchyFacetValue = this.props.expandedHierarchies
        .indexOf(hierarchyFacetValue);
      if (indexOfExpandedHierarchyFacetValue > -1) {
        // This accordion is currently expanded, so collapse it.
        this.props.expandedHierarchies.splice(indexOfExpandedHierarchyFacetValue,1);
      } else {
        // This accordion is currently collapsed, so expand it.
        this.props.expandedHierarchies.push(hierarchyFacetValue);
      }
    }
  }

  removeAllListFacetValues (e, searchFieldName, searchFieldValues) {
    e.preventDefault();
    const values = searchFieldValues;
    const field = searchFieldName;
    for (const value of values) {
      const { foundIdx, parsed, isQsParamField, param } =
        helpers.qs.getFieldQsInfo({
          field,
          values,
          value,
        });

      // Confirm the field value is set in state.
      if (foundIdx > -1) {
        // If the field is one whose state is tracked in qs and there is currently a param for it.
        if (isQsParamField && param) {
          const newParsed = helpers.qs.removeValueFromQsParam({
            field,
            value,
            param,
            parsed,
          });

          helpers.qs.addNewUrlToBrowserHistory(newParsed);
        }
      }
    }

    // Clear the selected filters in the component's state
    this.setState({
      selectedFilters: [],
    });

    // Send query based on new state.
    this.props.onChange(field, []);
  }

  render() {
    const {
      label,
      facetCounts,
      facetValues,
      field,
      value,
      collapse,
      hierarchy,
      options,
      showAllTitle,
      id,
      customComponents,
      onSearchFieldChange,
    } = this.props;
    const CurrentQueryComponent = customComponents.searchFields.currentQuery;
    const { truncateFacetListsAt } = this.state;
    if (field === 'sm_site_name') {
      facetValues.forEach((v, i) => {
        reactT(facetValues[i]);
      });
    }
    const siteList = options.siteList;
    // Create an object of facets {value: count} to keep consistent for inputs.
    const facetInputs = {};

    // Default field for publication category
    let publicationCategoryField = "sm_publication_media";
    if (typeof drupalSettings.publication_content_types !== 'undefined') {
      if (drupalSettings.publication_content_types === 'PDF publications only') {
        publicationCategoryField = "ss_publication_media_name";
      } else if (drupalSettings.publication_content_types === 'HTML publication pages only') {
        publicationCategoryField = "ss_publication_category";
      }
    }

    // Handle site name restrictions.
    if (field === 'sm_site_name' && siteList.length > 0) {
      facetValues.forEach((v, i) => {
        const key = facetValues[i];
        if (siteList.indexOf(v) > -1) {
          facetInputs[key] = facetCounts[i];
        }
      });
      // If only one option exists and nothing is selected, don't show it.
      if (value.length < 1 && Object.keys(facetInputs).length < 2) {
        return null;
      }
    }
    else if (
      field === "sm_topics" ||
      field === "ss_type" ||
      field === "ss_field_categories_list" ||
      field === "sm_tags" ||
      field === "sm_keywords" ||
      field === "ss_document_type" ||
      field === "ss_publication_category" ||
      field === "ss_supporters_category" ||
      field === "ss_event_category" ||
      field === publicationCategoryField ||
      field === "ss_news_category" ||
      field === "sm_event_category_media" ||
      field === "sm_countries_media" ||
      field === "ss_field_event_type" ||
      field === "sm_countries" ||
      field === "sm_region"
    ) {
      let total = 0;
      facetCounts.forEach((v) => {
        total += v;
      });

      if (total < 1) {
        return null;
      }
      else {
        facetValues.forEach((v, i) => {
          const key = facetValues[i];
          facetInputs[key] = facetCounts[i];
        });
      }
    }
    else {
      facetValues.forEach((v, i) => {
        const key = facetValues[i];
        facetInputs[key] = facetCounts[i];
      });
    }

    const expanded = ((window.innerWidth < 768) ? !collapse : collapse);
    const height = expanded ? 'auto' : 0;

    const facetValuesCount = facetValues.filter(
      (facetValue, i) =>
        facetInputs[facetValue] > 0
    ).length;

    const langcode = document.querySelector('html').getAttribute('content-lang');

    const arabicPattern = /[\u0600-\u06FF0-9]/;
    const frenchPattern =  /[a-zàâçéèêëîïôûùüÿñæœ .-]/i;
    const spanishPattern =  /[A-Za-záÁéÉíÍóÓúÚñÑüÜ0-9]/;
    const englishPattern =  /[A-Za-z0-9]/;

    const groupNames = (arr) => {
      // Replace original values with its labels.
      if (
        field === "ss_field_categories_list" &&
        typeof drupalSettings !== "undefined"
      ) {
        /*global drupalSettings:true*/
        arr = drupalSettings.categories_list_labels
          .filter((facetValue, i) => facetInputs[i] > 0)
          .map((element) => element.label);
      }
      const map = arr.reduce((acc, val) => {
        let char = val.charAt(0).toUpperCase();

        let charHandledByLang = "";
        if (langcode === 'fr') {
          charHandledByLang = char.match(frenchPattern) ? char : '#';
        }
        else if (langcode === 'es') {
          charHandledByLang = char.match(spanishPattern) ? char : '#';
        }
        else if (langcode === 'ar') {
          charHandledByLang = char.match(arabicPattern) ? char : '#';
        }
        else if (langcode === 'en') {
          charHandledByLang = char.match(englishPattern) ? char : '#';
        }
        acc[charHandledByLang] = [].concat(acc[charHandledByLang] || [], val);

        return acc;
      }, {});

      let mapObjectKeys = Object.keys(map);
      if (mapObjectKeys[0] === "#") {
        let hash = mapObjectKeys[0];
        delete mapObjectKeys[0];
        mapObjectKeys[mapObjectKeys.length] = hash;
      }

      const res = mapObjectKeys.map((el) => ({
        letter: el,
        names: map[el],
      }));
      return res;
    };

    var collator = new Intl.Collator(langcode);

    const facetValuesGroupedByFirstChar = groupNames(
      facetValues.filter((facetValue, i) => facetInputs[facetValue] > 0)
    ).sort(function(a, b) {
      return collator.compare(a.letter, b.letter)
    });

    // If we need to generate multiple list-fact accordion groups
    // from this list-facet field (i.e. sm_federated_terms).
    if (hierarchy) {
      // Iterate through sm_federated_terms array of values.
      // Each value is a string with the format Type>Term.
      // Define array of types which will render as accordion li links.
      const types = [];
      // Define object to hold data for each type:
      // {
      //   type: {
      //     items: [{
      //       term (the checkbox label),
      //       facetValue (the checkbox value, Type>Term),
      //       facetCount (the number of items with this value returned)
      //     },...],
      //     expanded: bool (whether or not this accordion is expanded)
      //   },...
      // }
      const terms = {};
      facetValues.forEach((facetValue, i) => {
        // Create array of [Type, Term] from Type>Term.
        const pieces = facetValue.split('>');
        types.push(pieces[0]);
        // If we don't already have terms.Type then create it.
        if (!Object.hasOwnProperty.call(terms, pieces[0])) {
          terms[pieces[0]] = {};
          terms[pieces[0]].items = [];
          terms[pieces[0]].expanded = (this.props.expandedHierarchies.indexOf(pieces[0]) > -1);
          terms[pieces[0]].height = terms[pieces[0]].expanded ? 'auto' : 0;
        }
        // Add the object for this facet value to the array of terms for this type.
        terms[pieces[0]].items.push({
          term: pieces[1],
          facetValue,
          facetCount: facetCounts[i],
        });
      });

      // Remove duplicate types
      // So facet values of "Condition>Bones", "Condition>Bone growth" should only
      // Add "Condition" type once so we only render 1 Condition accordion group.
      const uniqueTypes = types.filter((v, i, self) => self.indexOf(v) === i).filter(String);

      // Define array of accordion Lis which we'll populate with react fragments.
      const listFacetHierarchyLis = [];
      // Define array of checkbox Lis which we'll populate with react fragments, per type.
      const listFacetHierarchyTermsLis = [];
      // Iterate through types (accordion lis).
      uniqueTypes.forEach((type, i) => {
        // Populate the checkbox lis react fragments for each type.
        listFacetHierarchyTermsLis[type] = [];
        terms[type].items.forEach((termObj, i) => termObj.facetCount
          && listFacetHierarchyTermsLis[type].push(<li key={`${termObj.term}_${termObj.facetValue}_${i}`}>
            <label className="search-accordion__checkbox-label">
            <input
              type="checkbox"
              name={type}
              value={termObj.facetValue}
              checked={value.indexOf(termObj.facetValue) > -1}
              onChange={() => this.handleClick(termObj.facetValue)}
            /><span className="checkbox-label-text">{termObj.term}</span>
              <span className="facet-item-amount"> ({termObj.facetCount}
                <span className="element-invisible">results</span>)
              </span>
            </label>
          </li>));

        // Populate the accordion lis array with all of its checkboxes.
        listFacetHierarchyTermsLis[type].length && listFacetHierarchyLis.push(
          <li id={`solr-list-facet-${type}`} key={`solr-list-facet-${type}-${i}`}>
            <div
              tabIndex="0"
              className={cx('search-accordion__title', { 'js-search-accordion-open': terms[type].expanded })}
              id={label.replace(/\s+/g, '-').toLowerCase()}
              onClick={this.toggleExpand.bind(this, type)}
              onKeyDown={(event) => {
                if (event.keyCode === 13) {
                  this.toggleExpand(type);
                }
              }}
            >
              <span className="element-invisible">Toggle filter group for</span> {type}
            </div>
            <AnimateHeight
              duration={600}
              height={terms[type].height}
            >
              <ul className="search-accordion__content" key={`solr-list-facet-${type}-ul`}>
                {listFacetHierarchyTermsLis[type]}
              </ul>
            </AnimateHeight>
          </li>);
      });
      // Render the group of accordion lis with their facet value checkbox lists.
      return listFacetHierarchyLis;
    }
    // This is not a hierarchy of accordion groups,
    // just render the single list-facet accordion.
    return (
      <li id={`solr-list-facet-${field}`} className={`facets-${field}`}>
        <div
          tabIndex="0"
          className={cx('search-accordion__title', { 'js-search-accordion-open': expanded })}
          id={label.replace(/\s+/g, '-').toLowerCase()}
          onClick={this.toggleExpand.bind(this)}
          onKeyDown={(event) => {
            if (event.keyCode === 13) {
              this.toggleExpand();
            }
          }}
        >
          <span className="element-invisible">Toggle filter group for</span> {label}
        </div>
        <AnimateHeight
          duration={600}
          height={height}
        >
          <ul className="search-accordion__content" key={`solr-list-facet-${field}-ul`}>
            {facetValues.filter((facetValue, i) => (facetInputs[facetValue] > 0 || field === 'sm_site_name'))
              .filter(
                (facetValue, i) =>
                i < truncateFacetListsAt
              )
              .map((facetValue, i) => {
                if (this.state.filter.length === 0
                  || facetValue.toLowerCase().indexOf(this.state.filter.toLowerCase()) > -1) {
                    reactT(facetValue);

                    let label = facetValue;

                  if (field === 'ss_type' && typeof drupalSettings !== 'undefined') {
                    /*global drupalSettings:true*/
                    label = drupalSettings.content_types_labels[facetValue].label;
                  }

                  if (field === 'ss_field_categories_list' && typeof drupalSettings !== 'undefined') {
                    /*global drupalSettings:true*/
                    label = drupalSettings.categories_list_labels[facetValue].label;
                  }

                  if (field === 'ss_field_event_type') {
                    switch (facetValue) {
                      case "0":
                        label = reactT('Private event')
                        break;
                      case "1":
                        label = reactT('Public event')
                        break;
                      case "2":
                        label = reactT('Invite-only event')
                        break;
                      default:
                        label = reactT('Public event')
                        break;
                    }
                  }

                  return (
                    <li key={`${facetValue}_${facetInputs[facetValue]}`} className="d-flex align-items-baseline search-accordion__checkbox-label">
                      <input
                          type="checkbox"
                          name={field}
                          id={facetValue}
                          value={facetValue}
                          checked={value.indexOf(facetValue) > -1}
                          onChange={() => this.handleClick(facetValue)}
                        />
                      <label className="d-flex align-items-baseline mb-0 ml-2" htmlFor={facetValue}>
                        <span className="checkbox-label-text">
                          {reactT(label)}
                          <span className="facet-item-amount"> ({facetInputs[facetValue] > 0 ? facetInputs[facetValue] : ' '}
                            <span className="element-invisible">results</span>)
                          </span>
                        </span>
                      </label>
                    </li>
                  );
                }
                return null;
              })}
          </ul>
          {facetValuesCount > truncateFacetListsAt ?
                  <ShowAllModal
                  title={label}
                  triggerLabel={reactT("Show all") + ' ' + showAllTitle.toLowerCase()}
                  propHandleApplyFilters={this.handleApplyFilters}
                  filter={
                    <div className="unhcr-search w-100 mt-3">
                    <div className="view-filters mb-0">
                      <form className="views-exposed-form">
                        <div className="form-row">
                            <div className="form-item-keywords">
                            <input
                              type="text"
                              className="form-control bg-white"
                              name="filter"
                              id="facetsTextFilter"
                              value={this.state.textFilter}
                              onChange={event => this.setState({
                                textFilter: event.target.value,
                              })}
                              placeholder={reactT('Search')}
                            />
                            </div>
                        </div>
                      </form>
                    </div>
                  </div>
                          }
                clearFilter={() => this.setState({
                  textFilter: '',
                })}
                currentQuery={
                  <CurrentQueryComponent
                    {...this.props}
                    onChange={onSearchFieldChange}
                    currentQueryType={'list-facet'}
                    currentQueryField={field}
                    categoryMapping={this.props.categoryMapping}
                    onClear={(e) =>
                      this.removeAllListFacetValues(e, field, value)
                    }
                  />
                }
                  selectedCount={value.length}
                  onClear={(e) =>
                    this.removeAllListFacetValues(e, field, value)
                  }
                >
                  {facetValuesGroupedByFirstChar
                  .map((facetValue, i) => {
                    const filteredFacetValueName = facetValue.names
                      .filter((name) =>
                        !this.state.textFilter || name.toLowerCase().includes(this.state.textFilter.toLowerCase()));
                    if (filteredFacetValueName.length > 0) {
                      return (
                        <div className="facet-modal-group" key={'facet-modal-group-' + i}>
                        <h5>{facetValue.letter}</h5>
                        <ul className="list-unstyled pl-0">
                        {filteredFacetValueName
                        .sort(function (a, b) { return a.toLowerCase().localeCompare(b.toLowerCase()); })
                        .map(
                          (facetValueName, i) => {
                            if (
                              this.state.filter.length === 0 ||
                              facetValueName
                                .toLowerCase()
                                .indexOf(this.state.filter.toLowerCase()) > -1
                            ) {
                              let label = facetValueName;

                              if (
                                field === "ss_type" &&
                                typeof drupalSettings !== "undefined"
                              ) {
                                label =
                                  drupalSettings.content_types_labels[facetValueName].label;
                              }

                              if (
                                field === "ss_field_categories_list" &&
                                typeof drupalSettings !== "undefined"
                              ) {
                                /*global drupalSettings:true*/

                                let labels = drupalSettings.categories_list_labels;
                                for (var key in labels) {
                                  if (labels[key]['label'] === facetValueName) {
                                    facetValueName = key;
                                    break;

                                  }
                                }
                              }

                              if (field === "ss_field_event_type") {
                                switch (facetValueName) {
                                  case "0":
                                    label = reactT('Private event')
                                    break;
                                  case "1":
                                    label = reactT('Public event')
                                    break;
                                  case "2":
                                    label = reactT('Invite-only event')
                                    break;
                                  default:
                                    label = reactT('Public event')
                                    break;
                                }
                              }

                              return (
                                <li key={`${facetValueName}_${facetInputs[facetValueName]}`} className="d-flex align-items-center search-accordion__checkbox-label">
                                    <input
                                      type="checkbox"
                                      name={field}
                                      id={facetValueName + ' modal'}
                                      value={facetValueName}
                                      checked={this.state.selectedFilters.indexOf(facetValueName) > -1}
                                      onChange={() => this.handleModalClick(facetValueName)}
                                    />
                                  <label className="d-flex align-items-baseline mb-0 ml-2" htmlFor={facetValueName + ' modal'}>
                                    <span className="checkbox-label-text">
                                      {label}
                                      <span className="facet-item-amount">
                                        {" "}
                                        (
                                        {facetInputs[facetValueName] > 0
                                          ? facetInputs[facetValueName]
                                          : " "}
                                        )
                                        {" "}
                                      </span>
                                    </span>
                                  </label>
                                </li>
                              );
                            }
                            return null;
                          }
                        )
                       }
                       </ul>
                       </div>)
                    }
                    return null;
}
                  )}
                    </ShowAllModal> : ''}
        </AnimateHeight>
      </li>
    );
  }
}

FederatedListFacet.defaultProps = {
  hierarchy: false,
  expandedHierarchies: [],
  value: [],
};

FederatedListFacet.propTypes = {
  bootstrapCss: PropTypes.bool,
  children: PropTypes.array,
  collapse: PropTypes.bool,
  expandedHierarchies: PropTypes.array,
  facetSort: PropTypes.string,
  facets: PropTypes.array.isRequired,
  field: PropTypes.string.isRequired,
  hierarchy: PropTypes.bool,
  label: PropTypes.string,
  onChange: PropTypes.func,
  onFacetSortChange: PropTypes.func,
  onSetCollapse: PropTypes.func,
  query: PropTypes.object,
  truncateFacetListsAt: PropTypes.number,
  value: PropTypes.array,
};

export default FederatedListFacet;
